import React, { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cake, PartyPopper, Loader2, Pencil, Send } from "lucide-react";
import { toast } from "sonner";

// One-tap "Send wishes" reply into the Mess from a dawn birthday alert
export function BirthdayActions({ n, onDone }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [custom, setCustom] = useState(false);
  const [text, setText] = useState("");
  const done = n.wished || n.read;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/birthdays/wish", { post_id: n.data?.post_id, notification_id: n.id, message: custom ? text : undefined });
      toast.success(data.already ? "You already sent your wishes 🎂" : `Wishes sent to ${n.data?.first || "the brother"} in the Mess 🎂`);
      setCustom(false); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="mt-2 space-y-2" data-testid={`birthday-actions-${n.id}`}>
      {custom && <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={400} placeholder={`Your own words for ${n.data?.first || "the brother"}…`} className="w-full rounded-md border border-[hsl(var(--gold))]/30 bg-background/60 p-2 text-xs outline-none focus:border-[hsl(var(--gold))]" data-testid={`birthday-custom-${n.id}`} />}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={send} disabled={busy || (custom && !text.trim())} className="h-7 bg-[hsl(var(--gold))] text-xs font-700 text-[hsl(var(--primary-foreground))]" data-testid={`send-wishes-${n.id}`}>
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <><Send className="mr-1 h-3 w-3" />{n.wished ? "Send again" : custom ? "Send my words" : "Send wishes"}</>}
        </Button>
        {!custom && !done && <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setCustom(true)} data-testid={`write-wishes-${n.id}`}><Pencil className="mr-1 h-3 w-3" />Write my own</Button>}
        <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => navigate("/dashboard")} data-testid={`view-birthday-${n.id}`}>Open the Mess</Button>
      </div>
      {n.wished && <p className="text-[0.65rem] text-emerald-500" data-testid={`wished-${n.id}`}>✓ Your wishes are in the Mess</p>}
    </div>
  );
}

export const BirthdayIcon = ({ type }) => (type === "birthday_self" || type === "birthday_wish" ? <PartyPopper className="h-4 w-4" /> : <Cake className="h-4 w-4" />);
